import { useCallback } from "react";

import useClient from "hooks/atPort/useClient";

export const useUpdateSystemNotification = () => {
  const { client } = useClient();

  const update = useCallback(
    async (
      id: string,
      data: {
        homeDisplay: boolean;
      }
    ) => {
      return await client({
        method: "PUT",
        url: `/system-notification/${id}`,
        data,
      });
    },
    [client]
  );

  return { update };
};
